/* Animaciones de scroll y de pulsar (Iluminashop) */
(function () {
  var reduce = false; // se ve igual aunque el PC tenga las animaciones apagadas
  var root = document.documentElement;

  // 1) Barra de progreso de scroll + header que se compacta
  var bar = document.querySelector('.scroll-progress');
  var header = document.querySelector('.header-wrap');
  var parallax = reduce ? [] : Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
  var ticking = false;
  function onScroll() {
    var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight;
    if (bar) bar.style.transform = 'scaleX(' + (h > 0 ? y / h : 0) + ')';
    if (header) header.classList.toggle('is-scrolled', y > 40);
    parallax.forEach(function (el) {
      var f = parseFloat(el.dataset.parallax) || 0;
      el.style.translate = '0 ' + (y * f).toFixed(1) + 'px';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  // 2) Entrada escalonada: los hijos de una grilla aparecen uno tras otro
  document.querySelectorAll('.grid, .steps, .trust-row, .faq').forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--d', (i % 8) * 90 + 'ms'); });
  });

  // 3) Título del hero palabra por palabra
  if (!reduce) requestAnimationFrame(function () { root.classList.add('hero-in'); });
  else root.classList.add('hero-in');

  // 4) Onda líquida al pulsar
  if (!reduce) {
    document.addEventListener('pointerdown', function (e) {
      var el = e.target.closest && e.target.closest('.btn, .card, .icon-btn, .trust-item, .step, .faq summary, .thumb');
      if (!el) return;
      var r = el.getBoundingClientRect();
      var s = Math.max(r.width, r.height) * 2.2;
      var rip = document.createElement('span');
      rip.className = 'ripple';
      rip.style.width = rip.style.height = s + 'px';
      rip.style.left = (e.clientX - r.left - s / 2) + 'px';
      rip.style.top = (e.clientY - r.top - s / 2) + 'px';
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      el.classList.add('has-ripple');
      el.appendChild(rip);
      rip.addEventListener('animationend', function () { rip.remove(); });
    }, { passive: true });
  }

  // 5) Agregar al carrito: el ícono del carrito rebota
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) form.addEventListener('submit', function () {
    var c = document.querySelector('.header-actions a[href*="cart"]');
    if (c) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
  });
})();
